import { defaultIconProps, IconSvgWrapper, type IconProps } from "./base";

const SmartphoneIcon = (props: IconProps) => {
  props = { ...defaultIconProps, ...props };

  return (
    <IconSvgWrapper {...props}>
      <g fill="none">
        <path
          d="M17.3257 1.84442H6.67449C5.94609 1.84442 5.35449 2.43602 5.35449 3.16442V21.1572C5.35449 21.8856 5.94609 22.4772 6.67449 22.4772H17.3269C18.0553 22.4772 18.6469 21.8856 18.6469 21.1572V3.16442C18.6469 2.43602 18.0553 1.84442 17.3269 1.84442H17.3257ZM17.2057 21.0372H6.79449V3.28442H9.46449V3.51962C9.46449 4.04882 9.89409 4.47842 10.4233 4.47842H13.5781C14.1073 4.47842 14.5369 4.04882 14.5369 3.51962V3.28442H17.2069V21.0372H17.2057Z"
          fill="currentColor"
          className={`icon--${props.color}`}
        />
        <path
          d="M13.762 17.7624H10.2376C9.84038 17.7624 9.51758 18.0852 9.51758 18.4824C9.51758 18.8796 9.84038 19.2024 10.2376 19.2024H13.762C14.1592 19.2024 14.482 18.8796 14.482 18.4824C14.482 18.0852 14.1592 17.7624 13.762 17.7624Z"
          fill="currentColor"
          className={`icon--${props.color}`}
        />
      </g>
    </IconSvgWrapper>
  );
};

export default SmartphoneIcon;
